import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { priceNumberFormat } from "src/utils/Number";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

//ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

export default (data) => {
  var docDefinition = {
    pageSize: "A4",
    pageMargins: [20, 20, 20, 20],
    header: [
      {
        stack: [
          {
            columns: [{}],
          },
        ],
        style: "headerSection01",
      },
    ],
    content: [
      {
        columns: [
          {
            image: `data:image/png;base64,/9j/4AAQSkZJRgABAgEASABIAAD/2wCEAAYEBAQFBAYFBQYJBgUGCQsIBgYICwwKCgsKCgwQDAwMDAwMEAwODxAPDgwTExQUExMcGxsbHB8fHx8fHx8fHx8BBwcHDQwNGBAQGBoVERUaHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fH//CABEIAMgBoAMBEQACEQEDEQH/xAAdAAEAAgMBAQEBAAAAAAAAAAAABwgFBgkEAwIB/9oACAEBAAAAALUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+UX7nsQxkVTQDEQjh5Wkcib45HdM0ECT2Gv6VJfqABiuYFyrFCscD9FA0KgeG9fjtxZty48T9zjdT2NM5y9HdwEAUq6VbUADFcwLlWKPPzX1u+8uijkV9BtsqZsFmHLawtlYdqBbKzymldrF3JEAUq6VbUADFcwLlWKIApXs26X5FAcP0T/YctrK20c9tnvFgeamdwfSzOEAUq6VbUADFcwLlWKfznNsU8Us6JSCQHSiSrKTd9zltZW2mE5wzvcKqFZuh/O+ztrCAKVdKtqABiuYFyrFIcodfGWuacs3cEK1S0LbbwyM5bbPt0a/noXs3NObLn0thfpZ7kAUq6VbUADFcwLlWKUA1foh+qu1o6S7SERUv+fSn0cttn33dLD7VW2n3QTetC5+3EsggClXSragAYbmJcqxUc88QWVt/wDzUsrmUE0h6JyDy2srbQ+XNvVA23pH9IApV0q2oAGg86byzfRyKrhiC4k6W4bm3b6yytNQek23ctrK20IKpBbTazUqm3gnSAKVdKtqAFcPJC8cdLcbzdtPakaZzhtdaOhEYWW/dZ5Lv05e2Otoc7vn0VH850+jofAFKp5yK2+TB+KCxXsdu5zrlAt7M2FO9ZvTiqdwl+ptuBmFBpssa0OlloptCEKy3S1OrIvhmQAAAAAAAAAAAB4fX8PR/fBkPl/fh6wAAAAAA0zB5/TPh9M76MX69c9swAAAAAADS8RpWYzGK2L+6tkUqfYAAAAAAMb7n5+mMyvi9L6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//EAEEQAAAGAQEFBAgDBQYHAAAAAAECAwQFBgcIABAREhQTICF1FRYYMDU2N3NTVnQiJDJQVRcjJTEzdjhBUWBhcID/2gAIAQEAARIA/wDj526QaNVnbg3I3bpmVWP7UeCfzNtSchU+8R68hV5D0gzbK9Our3LRYY+t12RnpE3IyjW6jlbbTPmB5foKVazKpTTsc7UWEO9Z7fWKtHDI2GTQjGYcQKpYdaVAZLGShYp/L8o8O3Za4oY6vB9U3KCXMPE9C1B4vuy6bONkxZyivgnG73mqXDLN4u0cSy5V2yh0lShqvwiIgAzC4AP/ADa6mMHulORO0JlN4Bxr92p1iDjAzbGTMAcTJ90moIhtR5qd24erXZjDlN3brfanSIpKVs770ewXXK1SW9qPBP5m2iZRhLxTOVj1e3YSCCTpmt7y2fKsz+hc7tEvyDO+aj3daGQgbRkdRGan98+EshKhgvIJqLkiMllVBJGODdFLAAgYAEB4gPiA9zM2WIzGtTNKrEK5k3RhQiWFuudlt8ytMWF8o+eqiPASEOocCEKJzmHgUr2GmGBCnfMXDQhx4FMAiAgIDwEPEB0wagnsu4Ro1tciu/EohCym6bVUWmn6qg8yijlY5zbklVUVSKonMmqmIGIpibVVcqw6QYWlZWfr3ECHNDTMZNRTSWi3BHcc9TKs2cbswX1Ki4+lp8TF6xNPsI1MHrsHnW9sfrO07bqMR3xG84/ibCAh1ayQJSJO5rV+lkV5433Yn+llN8jjfe2z5Vmf0Lndol+QZ3zUe5Iv2cdHuZB6qCLNmkdw5WyNc3l0ustZXXEov1xMgltpgyF63YzatnKnPLQHLHPO7q/sziTyypECcelgWiDdNOjVGRuFti61HiBHUksCQK46xNSaBGptYJgQHfIBXMo7ZtHjZRq8QTctVi8qyGoXTOqzfNZ3HkWos3frAg+hcN6SQiHjKxXZ2JpNqoRw0iN0t8VeffU20ZV+BmJS0hLRrWRBFBoKISWH8VyRDFd1KJMJ/wCJTKGj2tvI9d/QjHjZVIonJFOG67Zwq3cJmSXROZNVLRTdnDmOmqa5OJyMRLIRwbtY+Q/S1taU5mrxZQJQWfBto3yGEVanlNeK8rKcL27Du61fpZFeeN92J/pZTfI433ts+VZn9C53aJfkGd81Huawch+hKShVWavLIWIw9TsACIgABxEfAAyHj2dok6lDTRQByq0bvCG0x5DCn5MaouleziJ4Ajnvd1RRq7HNs+ZQB7N4DZygbBVyjqflODnJMeSOTOog7VQXQcIJroKFVQVKB0le7LfFXn31NtDnxW3fYZb9STBoxzdaUGpQKkddFwYNHLhZLLxiJlESLxjpNYdr5bmNPp8tZHvAUY1uZUqcvKPpaVeSj9QVnr9ZRy5VHHk+GOgvnZ/4OMgMbwh5Z/DyzOWj1RRfMFk3DZWjWxhbqjFWRj4ISTcqwp79av0sivPG+7E/0spvkcb722fKsz+hc7tEvyDO+ajvOchCGOcwFIUBExs15APe8jSk2Q4mjyG6SKLpix+NtyezXcJ88VAcJJ5trDx+E1R29qaJcz+vH/eBARAQEB4CHiA4IyCF6xtGSqynaSjYvQy3c1V4be2+Fb2iBQFxPQyYpuGogIDwHwENsZ6g8iUBIjJg5JIQhB8Imi6vccT3I3niK1t+bgHFhIMJBom8YOUnjNYOZFzvlvirz76m2hz4rbvsMt1yuddp0C4nJ52VqyblHgF1tDu12yWsTsvItJuVHApaJa6svbZ6wmIPTsWJWRDba0ch9o4jaIyV/ZR4SMuERFPpeVZxTBPtnz9dNs1SUxRCGxH/AGceAsQj+jKvKxj6Kk3cY/SFF6xWUbuUdF2QuVSToj1TwPxkYgN+tX6WRXnjfdif6WU3yON97bPlWZ/Qud2iX5BnfNR36psh+qmNV49qryS1jEzBsG2ljH/qrjJvIOU+SUsYlkHAycaylI11GvkwWZPUVG7lK/VF7T7lLVt5xFWNcGSIppEyF6v349cdqcsbZCgkn3ctaXahdnC0vEqegbArxMqtf8HZIoxlFJiKOrGk48JXbH+UrrQpEHlekDpJCYBcR+Gc11/JkQc7cnQzjIpfSUXulvirz76m2OMsW/Hi75atqIJnkSpkc7PtWGa3RBInLIM+IcBNY7XZbK+66fk3Mm6DiBVK3WpyyzLaGg2ij2RdGAqSOIMbMseUhpAImKs8ERcSbqfm2EFCP5mQP2bGOQUcuD3G0SNqtEnYpE3F3JuDrnLo5oHpe5u7a7T5mUAn2bQdtYmP/Q12bWtolysLCnyuhplpf1S1RdiYD+9Rjgi5SQU1HzkKxmY5QFWMggm5bKbtav0sivPG+7E/0spvkcb722fKsz+hc7tEvyDO+ajv1KZD9csmvemV7SIheMdH7YqqbW1X6Ih3y6baNUWBWRXTtFRSTKmnLx5EyABSE9bKr/WWO2sevwT5WJucO9auV+Ho6UTZu3LN2g8aqGRdNlCrILYvu7a70WJsiPKVV4iAPEu4IAYBAQ4gPgIZI0x44uCSrhm1LX5owCJH2Q8d2Sg2NWDnUQKqUOds5x7dpSlW+OscccQUZqAK6MbINJKOayLM/atHqKbhuptLfFXn31NscYnt+Q13yNbTQUPHFTO52b6PswqqAQ5I5Av4lY0RPjKkUtNjSTSD+NtQsYUmiMRa1uNI1OoAA4ebazchAwr7CkM1eDqWEHkkUAER4B4iO2FIyrUTHMVBrSrFOSMTqpXb1sqv9ZY7ZxjapecbSsMlLMTyKResit2jTIYyNcfUp6rzO4cwuo4N2tX6WRXnjfdif6WU3yON97dVyIU2eXOAiRKOdnMG2iX5BnfNR3Z/yF6jY0kZBur2cs+DoIoe9oyyF0M9IUh6rwbSpReRhdjGKUomMIFKUOJjT+XcYQHMErZ49FQv8SFQuFft8GlOQDgXcWudRNFfdrFrjKQxaSYOQoPYV4idFbbT8+WfYZqayoiJiMgQDdLfFXn31NtDnxW3fYZdx27bM2qzt0oVFs3TMqutlK8Obxe5axq8xUnawlZJd3FV6cUe+xNiTE3YNlgI/TbOUHTdJy3UKq3XIVRFXbWr9LIrzxvuxP8ASym+Rxvvc9WJCBxFZ3aigEO4ZKMW+7R7EHY4fK6MHAJWRdOyDtq1yH6yZD9AtFeeMrJTNdqRVH9ttsXXGAD1Ek4Kjzho2xHw/wBeWH/z7G2I/wAaV29jbEf40rt7G2I/xpXbUhgyNxw4iX8AZwrBSBTIKmr85IQM4wmo4/Zvo5dNy3NULPH2msRlhjh/dJNuRdMuYK8rYcX2aIQIKjhdgqduntouvTFevSVLcKFJIs1zP2RN2tC9skK9G0tuqU8g9XK+fE2xFAqwGMazErkFNw3j0Bcp7S3xV599TbQ58Vt32GXc1c5DGvUAtdZq8klZTGQPuxZpLp8vRIqXtaj9OYkUuqOj7G2I/wAaV29jbEf40rt7G2I/xpXbK2kyoQ1DlZiqKP1JeNT6oqG2kjIYWLHw152rzSlaMCBQ21q/SyK88b7sT/Sym+Rxvu9Reouaptrjq9UlUhesBK6nNorW9AmYAMtWnSUgBfEua89T2TXCDYzcIyAZHFRrGxMW/lpNpFx6JnD56qRBshRquhVafD11AQOWMapoHUyxekKNQZaxHMXqW6QpsE3Dhdy4VcOFDKrrHMoqroux74Sd7epf9Y6IHuZhoSV6x7LQHKAvDp9vGnVSVRVOiqQU1UzCRQmi7IXaNZOiPVf20BGRiA21I4kdUW6rvmaBvVqbUO4j1YScl4KVbS0Q7UZSLQ/aN3NQ1suUWibe2wHVLkAAO/t2to6jNRCpQBkHJyiBH05OS87LOZeYdqPZJ4cVHLnTliZze7ug6eICNahlCOZNTdZkSI2SVRTDgmm8cEIGhz4rbvsMt4iABxHwAP8AMc85CG85KkpRFTtItoPQxW2C8fmvWSYyIVT541A3WywgAFAAAOAB4AG8xSmKJTABimDgYub8fmouR5SGTJyxqp+sihwHkIaNkqNkV1OSKej0EqACAhxDxAf8h1q/SyK88b7q3q/u8DXYuDbQ0Yq3imaDFFX22r//AEKK29tq/wD9CitqvKrS9aiZVchU1pBk3dKp95wC4oKA3MUi4lMCR8oYMzHETchKy0ctOFdrqOFphVJVFQyapDJqF8DErONL9Z1yIwUC9e848AWwBpvb0NQtisR03tpOQSt09tVNTypdXsTCVmDXewLAou3C6OmvNiipExrKqYHMBRUpFUYVKpRVcY8OnjG5Uefu58053d5kd9MU2GM/ipcAeLbUHD2e6dcYqyM6s4FWOXKodMhuchTcol5gAeW1VWCtUE6g5xqV3HOy8qieS9JF4r66zyqgNihuImIlJwszFLihKMHDBco8DJRUBOzCwIxMa6kVjDylTxppHu885Rd20Br0NxAx0anUq/U4JvBwLQjOPbB+yTdYtO+ZnVgk3LesLqILu11Ej6TsZXqmSFkVs8SpGpvUWpWpt2cHNuTxxKNKlHryE3JlBikU2nnNBUQWGqO+Q3gAaXcRSdFrL2Rn2vTWGZULzod3VJiGUvNdj5KvNOrsUSryFQ9m7Nv5WX2wye4hjuLZ3BioxnY4nRrl1T0m03DH0fGVpgeRfIyyLlRD2bs2/lZfb2bs2/lZfb2bs2/lZfb2bs2/lZfalsXTCnQTF2mKTtpHNEHCX/ZklPQcWKYSci1YisPBIEVkV0iLIqFVSUDmIo9lYtgKYPniDUVuIJAmomoQFEzAchvEpjGKUomMIFKUOJjR9ir8iudvHybR4un/AKiWzd21clOZssmuVM4pqD1TbqRa9qTqgJ2ooOpeJaLkbu3qDddUOKaQCBgAQHiA+ID/ACjMF2eU2gSMzHpgtKj2bWLSqmAKUzadZa2hLXaHhQPLS9JxfA0uTkl6+u6bRUiBBCBzMxqT7J+OW1sK0PBqIzwOC4dLAM8n2uKojjqKEgzbKnTnI5zlLKExVZByshRKgRsElHzenvF76P7GNiU4CSR4GYS+FLZOTtYesLEcFbHWZBxCSzjTx8Ctn+65fZP/AIknH+zUNr/GUKRzyzb3YrA8SFUVOltgE7Ikpd2FacHdY+ZSDclZV/lGYqW+uGP5GIjDglLlFJ3FqVLPdHkWHY2R+hV7K0DspeHi4Gm3vN8faaZH/wCFQaq72fs+caZEXPIdBrcsBujfNbAXtMO2BSO6jG880bxtor5OYgTEsfFuU5mxS6SpqNcytTOZSez3i2LjgctZxtNPFQ4MovCdVnIatv5OwpghYLTIuJyRaY0ttcoU5cKhbn6MG9PNvJeNcY/l0rnmCwXSIAytZYRSFfYyM/XoCe1ENGc5GNJVonUVliN2bNmybJtGaCbZqiHKkh/KZSs1uWUIrKxLOQUTDlIds1bNW6bdqkRBukHKkidq2UXScKJEOuhzAiqdiyUdJvDt0zO0QEqThVJJVMySpCqJnASnJHVOrRjnqo2GYsXPAQ7faUg4SWTInKx7aQTTERTI3bt2yJEG6REUEw4JpdK26kHXZE6oCdkC/wD6x//EAEgQAAIBAQQGBQkFBQQLAAAAAAECAxEABBIhEBMiMUFRIGFxgoQFFCMyQlJigdMwcnODkTNDUFOhk6LS1BUkYGNwgIWSsbLh/9oACAEBABM/AP8Ak+oThRAWY0AJNAOFvMfKH+XtqZ4MMmEPhwzpEx2WGYFOjWhIRahFr7THZUczaubXS9O0kVBllExaPLcoXn053ALkZ4Y0FXkb4VBNnwXWJs9648cn/dGLQXtJmw8DhaKEV6q28oKLvOxPsoatFI3wo5PQFzvJAdGKsKhOYsbneqD9I7S3a+QjP4pYUFrreI5XUfEisWX5jpVAX/SgbGZCTn+0rd6c8+lqppqzOjyKuGBJW9WJjWlMreY+UP8AL2wsmOGZBJG2FwrLiVgaMAftfyW0eGi6I4QRsRd4z9+VS5+4Odq0Bu05AZm/CcLJ3bDcR0Saa2alSz0zEcYzc9g3kWc7Ea8EiQbKIPdUWUVJPIAWnieMEjgCwFhvraZqvKEFfNpmPrPQEo5NW3HOldGQqWkJJy0oSrKwzBBGYNpTjvsC+9HMxrJT3ZCeoraM1VkYVHWDzBzByOlqbd7m2IhQ78J22HuqbYjj1mLFjxb8WLOtlFAl7i2JhTgCwxL8JHR8He9Hg4/tfyW0eGi6DeqkUSl3Y9QUE2Jrq4EGCGPuxqoPM56DvaNF/wBWk70Qwk8WU9H2dZeEF5kftYSop+6LMCVjQAvJIQMyEjVmPZaVVe9zniXlpUA+4tFHK0yrJG6ngysCCO211UvqZX9SWJfZibcw3IfhOzcpCqQyxsHRprwhBdlI9WOg+Jhp75te4I5whZ5cWHWK1K0FaWjucMUhoKftIlR/62mkaW6z0zwI8haSJzwJYrw2d4cUZXQ0ZWB3EEWOeGOVsF4QclD4GHWx0g7LX2dQQDz1URA7WYaGOS3yBc1HD0sQPzRR0fB3vR4OP7X8ltHhougpoyXKEgvWmY1r4V6xiFhvrZfVInjBZR+HKHjPMrWzGiK7tW7ynhsy0Wp3KzdE5Yke7Rqf0dGX5WpXVx3mJodZlwQuGPVWyEMjowqrKwyIIzBHS75t35tI/mXm6xTyn5ySMbCtAoeJ6nqxIugmmslOzDEOuSRlX52PtSSsXc/qbUOLFgxa37mLYr72Vh7MkTBlP6i1cRjk9WWIkcY5Ayns6Hg73o8HH9r+S2jw0WkmgAGZJJseF0gJEZA4YyWkI5sbEVVnjYebxnhtS0ah3qrWA2muc5CvXnq5MLdQxWG+tiQWN5gADO1P5qlZO90EFZLxc6lyEHtPExLKvEFuNBovwMkSVNTqWBWSLiaK2GuZU2n9PdCTwE8YBXvoo67QOssbjmroSp+XQ75t35tBI1kr02Yok3u7cAP/ABYGoRWOxGDxCIAvysd2tvUqyZdYS7n9dCn22BW7xNTkuJyDzU2HtSysEQfqbEUPnAGMXmme15x6Xts29ZImKOvyIsfeAC3mMHswuo+8eh4O96PBx/a/kto8NFpB2lgoPOpB2RsE6i40EUZYCKXWP+zOPtc2O54pVKOvzU2YUMkJ2oZfzImVvnY7lvsVTAerGCydZK8ujEmK7XhzxmhBXCx99COZDG1zrPdSBlVnUYo6/wC8VTokJe6zjlJETStMsQow4EWdsRXFkJYmyxxk8aVU5HgTo75tPEJQREWK0qRT1zaC6XevbWRJKWvMjSYATXCgJoi9SgC0Y/VmO5VXezHIcbKKCW9SAY2FfZUKEXqAtlXBEpYgV3k0oBxNq1CKTRI1+GNAEXqFjua+XhSoI56uLEe1lOhRsrfbuArVoKDWR4WHMhjapAdRlJGxHsyISh6jYcUlUMK8iK5jgdPg73o8HH9r+S2jw0WlTVG1THXSimR1ktaHioW0ziNFu0PpJRiYgBnVcC/ERZbxCFVQKAABsgLecw/4rQTRyOQMUl3lKoScttGb7osuTJJGwZWHWCK2XdHeY9iZM86B1NK8KHoncRa4IEiZzn6a7ikb57yuFvitHUw3iEmiyxMQKg8RvByNgaLNA2UsTDiHX9DQ7xYbmjlUOjfNTo75tPKIgBKWC0qDX1DaS9VX+4jt/S3kuNnZuyecIF/sjZqyXman8yVqsRXPCKKOAGgbxdIX9Ep/EmWvc0ecQg+dzgNIp2v3Ywx15LbzmH/FbzmGvnV3BZFG1+8UtH2NoY5m6TNtoo3+imNe+OWnwd70eDj+1G+iwOTSujw0WgHaE84NZB+FGGftA59NjkL1CvpkUc5IVxdzr0HIADibJOs0w7YodZJ/dsY3ixGJyjbEio42l4jTTa1d5OpkjB5MzIx+7oJrs3eRoU4D2Yxo75t35ug5oqRoCzMx5ACtmP7O7R7EKduAAtT2qnpLnrLrLsTrTicBJX4gDZTVWRxiVgeRB0eDvejwcf2taMZb4PN1w0zqNZi+VdB4qmC7f+13OgHJr45BvLdwqsfap52Arq498spHKOMM57LecxfRt5zF9G3nMX0becxfRteXWR472hLULKqCkkZ2RT2WscxjiYMARxBpQjlY5lCw242+JGqp6xZd7TQjXRKKe88YGgkAyXeYKsgUcTHItT1MOWlSCY7vCGEYYcNZI1R906CACs0q62VSBydyNHfNu/N0FNGW5x0M5P4lVj6wW5aLtMkaRxS7UK4Wjc4tXhLZ7zS3nMX0becxfRt5zF9G14lSVJIYtqZQqxocWrqy9Ypx0Mas1ykqbu2fuUaPLcFXno8He9Hg4/s5UWWNxItY7owO0KocbFSDmtDvtdJo5IWbnik1bKDyo1lfWM0tCuumei4mwkhQBRantsmZeSRgqgfM2G55FX0j99yW+dm/eXqXYhWnHaOJvhBs5qzO5qzMTvJJsw7GvMq17qAj4h0TTZvcO3Fmd2MjAx91jZhRlZTQgg8QbMd8bELeYh91sLgfEx4aFFUilc4pbsx4FDUpzSm8hrRGjq275gjIg5EZG3k6QRl6cTBIMIbnSSnULeUZFYRk8RBFkx5Vkp1G0pqzNu7AAMgBkBkMrOPRyspxR3YcCZCNoe5Xq078llYC3fm6HDzaBiA4/EctJ3rUqBdYCCyn8RisfesNwHQOYIPA2oaG6zksiiu/VmsZPNbVoognIGsP4ThZOwHno8He9EgvGNku0SxKzYZAMRCZ0FqXn6tqXn6tkrhVpolkYLWpoC2XTcFlD02SygqSK7xW3k9TeUkZ2LM7og1kW/2lA5WcFWB6wbLEyQCvvTPhiXvNaPahuauKMEY+vKwNGemQyHEmySQokl7kqijC7q3oo60PxmzzXfCtTSrUkJoOywFMcnrSyEc5JGZz1npRPDGIr05InQiR0O0w1lae1ThYT3YayI7M0ROt/eRsy/OzZEV4GzbwfZdG3q6nNWG6yUW/Rrvo8WQlpurHmfdFr1E8LgjgVcKbXSGSdieQEaseNmKtfpV5JGMSxV3VkzHumy5s7H1pJGObu1M2OkTXYBkeRmU5y8QbSPE+MxtKXA1bvuxDfpu/rxRzgiWbeKYYwwBr6xFgYi/zQPiH6WYqzw3WIejQlS1GZmZmFfdrmOkrKjTXWegdQXKrVHCsKndi52112+raVkcyxw0EMuKNnBxR4Q1TXEDZGRCIlu14QvWRkGTSKN/G2uu31ba67fVtrrt9W2uu31bEglZI4EV1JFRkwp/sbeZo4cZ3UXGVr8rIQysDuIIyNp5EjLkUrhxEVpUbrKQQR1EWOQAHE2u88crr95UYkaI2DhXX1lOEmjDiLYhrNWThx4d+GuVbSyojsCaVVWIJzsNxH8JahBvV5cRRkg78BbHTjSlvKtb0XlZdoRJJVERTklFqBxs0pkuUEqkl5YEfEyF65gNT+lL+yJBXUXbBVnKgHFTDnvtDK09xg8qO7axLq5LLRotp8LHPsFIHeE+Ub/ek1qpK64WMMSb1B9bPjUeTK3e9QSr6kgdSMdDwb/7ZRQTyXUjDOBQftEYZ8TU2/MS3/VJbeUnjjiE48ophKtIVo+AvuNaVsXeWJXaDFforvI9cUSS4cNCRx41P8IYhQL1dZFljGI+rjw4K8K1t5UcXR4rwg9IIzMVDoT6hBrTrsBMIb/fmXVQ3a7mQ4W1Z23ZBh/pVMnjkW73Z45F60dQ3I7jla6xJBdvKNyJpHf7uiBVq26UAZNy3LEjSr5P8oXVNQBOFqVimQ1xc8hut5LkW93qeVskjWOIsVLH36WFaXdr1TBd8/wCWiivImnC1/dbvd71cb6VeN4ppCsbMtKMta17DQqVjvcyXh71M0NQCyxs+En9LX2CO8RrIPKcahwkqsoYKxFes2hRY40XkqqAAOz+FXq7xTMo5AyK1LRKERVHBVWgAsygugcANhY5ripnSzIpkRWrUK5GIA14WYAqQd4IO+12u0MUlDvGJFU6L1DHMqk0qQJA1N1o1Coo5BRQC2EazVk4sGLfhrnT/AIZf/8QAFBEBAAAAAAAAAAAAAAAAAAAAoP/aAAgBAgEBPwAin//EABQRAQAAAAAAAAAAAAAAAAAAAKD/2gAIAQMBAT8AIp//2Q==`,
            fit: [100, 100],
            style: "headerLeft",
            alignment: "left",
          },
          {
            text: "Budget Adjustment Requisition",
            fontSize: 16,
            style: "headerTitle",
            alignment: "center",
            width: "auto",
          },
          {
            stack: [
              {
                text: `Adjustment no . ${data.DOCUMENT_NO}`,
                fontSize: 12,
                style: "headerTitle",
                alignment: "right",
              },
              {
                text: `Date : ${data.REQUESTED_AT}`,
                fontSize: 12,
                style: "headerTitle",
                alignment: "right",
              },
            ],
            alignment: "right",
          },
        ],
      },
      {
        style: "tableExample",
        table: {
          headerRows: 6,
          footerRows: 1,
          widths: [84, 84, 84, 84, 84, 84],
          body: [
            [
              {
                text: "Requestor Name : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.REQUESTED_BY_NAME}`,
                border: [false, false, false, false],
              },
              {
                text: "Department : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.REQUESTED_DEPARTMENT_NAME}`,
                border: [false, false, false, false],
              },
              {
                text: "Brand : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.REQUESTED_BRAND_NAME}`,
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: "Budget Year : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.BUDGET_YEAR}`,
                border: [false, false, false, false],
              },
              {
                text: "Budget Type : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.BUDGET_TYPE_DESC}`,
                border: [false, false, false, false],
              },
              {
                text: "Adjustment Type : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.ADJ_TYPE_DESC}`,
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: "Project Code : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: data.F_PROJECT_CODE && `${data.F_PROJECT_CODE}`,
                border: [false, false, false, false],
              },
              {
                text: "Project Name : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: data.F_PROJECT_NAME && `${data.F_PROJECT_NAME}`,
                border: [false, false, false, false],
              },
              {
                text: "",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: "",
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: "Budget Code : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.F_BUDGET_CODE}`,
                border: [false, false, false, false],
              },
              {
                text: "Budget Name : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.F_BUDGET_NAME}`,
                border: [false, false, false, false],
              },
              {
                text: "Department : ",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${data.F_DEPARTMENT_NAME}`,
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: `Budget Remain (${data.CURRENCY_CODE}) : `,
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${priceNumberFormat(data.F_BUDGET_REMAIN)}`,
                border: [false, false, false, false],
              },
              {
                text: "",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: "",
                border: [false, false, false, false],
              },
              {
                text: "",
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: "",
                border: [false, false, false, false],
              },
            ],
            [
              {
                text: `Amount (${data.CURRENCY_CODE}) : `,
                alignment: "right",
                border: [false, false, false, false],
              },
              {
                text: `${priceNumberFormat(data.AMOUNT)}`,
                alignment: "left",
                colSpan: 5,
                border: [false, false, false, false],
              },
              {},
              {},
              {},
              {},
            ],
            [
              {
                text: `Budget Remain After Adjustment (${data.CURRENCY_CODE}) : `,
                alignment: "right",
                border: [false, false, false, false],
                colSpan: 2,
              },
              {},
              {
                text: `${priceNumberFormat(data.T_BUDGET_REMAIN)}`,
                alignment: "left",
                colSpan: 4,
                border: [false, false, false, false],
              },
              {},
              {},
              {},
            ],

            [
              {
                text: "Reason for Budget Adjustment Request : ",
                alignment: "left",
                border: [false, false, false, false],
                colSpan: 6,
              },
              {},
              {},
              {},
              {},
              {},
            ],
            [
              {
                text: `${data.REASON_ADJUSTMENT}`,
                colSpan: 6,
              },
              {},
              {},
              {},
              {},
              {},
            ],
          ],
        },
      },
      {
        style: "tableExample",
        table: {
          widths: [102, 102],
          body: [
            [
              {
                text: "Prepared By BU",
                alignment: "center",
                fillColor: "#F0F8FF",
              },
              {
                text: "Reviewed By BU",
                alignment: "center",
                fillColor: "#F0F8FF",
              },
            ],
            [
              { text: `${data.REQUESTED_BY_NAME}`, alignment: "center" },
              {
                text: `${data.REVIEWED_BY_NAME}`,
                alignment: "center",
              },
            ],
            [
              {
                text: `${data.REQUESTED_AT}`,
                alignment: "center",
                fillColor: "#F0F8FF",
              },
              {
                text: `${data.REVIEWED_AT}`,
                alignment: "center",
                fillColor: "#F0F8FF",
              },
            ],
          ],
        },
      },
      {
        style: "tableExample",
        table: {
          widths: [102, 102, 102],
          body: [
            [
              {
                text: "Approved By BU",
                fillColor: "#F0F8FF",
                alignment: "center",
              },

              {
                text: "Verified By Finance",
                fillColor: "#F0F8FF",
                alignment: "center",
              },
              {
                text: "Approved By CEO",
                fillColor: "#F0F8FF",
                alignment: "center",
              },
            ],
            [
              {},
              {
                text: `${data.VERIFIED_BY_NAME && data.VERIFIED_BY_NAME}`,
                alignment: "center",
              },
              {},
            ],
            [
              { text: "", alignment: "center", fillColor: "#F0F8FF" },
              {
                text: `${data.VERIFIED_AT && data.VERIFIED_AT}`,
                alignment: "center",
                fillColor: "#F0F8FF",
              },
              { text: "", alignment: "center", fillColor: "#F0F8FF" },
            ],
          ],
        },
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      tableExample: {
        margin: [0, 5, 0, 15],
        font: "THSarabunNew",
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: "black",
        font: "THSarabunNew",
      },
      headerSection01: {
        margin: 10,
        marginBottom: 100,
        fontSize: 10,
        font: "THSarabunNew",
      },
      headerTitle: {
        fontSize: 22,
        alignment: "center",
        font: "THSarabunNew",
      },
      headerLeft: {
        alignment: "left",
        marginBottom: 20,
      },
      headerRight: {
        alignment: "right",
      },
    },
    defaultStyle: {
      // alignment: 'justify'
    },
  };

  return pdfMake.createPdf(docDefinition);
};
